/**
 * Představuje nastavení jazyka.
 * @includeToDoc
 */
export interface ILanguage {
    /**
     * Kód jazyka v TescoSW formátu, nedrží se žádného standardu ani formátu.
     * Může obsahovat libovolný string, který by měl být pro aplikaci unikátní.
     * @example EN, CZ, MyLang, XYZ
     */
    readonly code: string;
    /**
     * Kultura ve standardu ISO 639-1 nebo v kombinaci se zkratkou státu.
     * @example en, en-US, en-GB
     * @see https://www.iso.org/iso-639-language-codes.html
     * @see https://iso639-3.sil.org/code_tables/639/data
     */
    readonly culture: string;
}

/**
 * Představuje nastavení jazyka s dalšími informacemi.
 * @includeToDoc
 */
export interface ILanguageExtended extends ILanguage {
    /** Zda je jazyk preferovaný jako primární. Takový měl být jen jediný. */
    readonly isPrimary: boolean;
    /** Lidsky čitelný název jazyka */
    readonly description: string;
}
